/* Variables definition */
export const sp_hid = {
    acpm: import.meta.env.VITE_SP_ACPM_HID,
    stats: import.meta.env.VITE_SP_STATS_HID,
    clics: import.meta.env.VITE_SP_CLICS_HID,
    contact: import.meta.env.VITE_SP_CONTACT_HID,
};

export const _spURL = import.meta.env.VITE_SP_URL;
export const _spURL_acpm = import.meta.env.VITE_SP_URL_ACPM;
// var sp_tracking_consent = 0; /* no consent by default */

export const sp_credentials = {
    login: import.meta.env.VITE_SP_EMAIL,
    profil: import.meta.env.VITE_SP_EMAIL,
    sessionId: import.meta.env.VITE_SP_SESSION_ID,
};
